import React from "react";
import ScheduleView from "../views/ScheduleView";
import FinanceView from "../views/FinanceView";

export function renderScheduleMenuContent({
    schedules,
    students,
    teachers,
    addItem,
    updateItem,
    deleteItem,
    selectedDepartment,
    userProfile,
    currentTheme,
    setActiveMenu,
    setStudentListType,
    setTargetStudentId,
    setTargetTeacherId,
    setDetailReturnMenu
}) {
    const handleNavigateToMemberDetail = (member) => {
        if (!member) return;

        setDetailReturnMenu('schedule');
        if (member.type === 'student') {
            setTargetTeacherId(null);
            setStudentListType('student');
            setTargetStudentId(member.id || null);
            setActiveMenu('students');
            return;
        }

        setTargetStudentId(null);
        setTargetTeacherId(member.id || null);
        setActiveMenu('teachers');
    };

    return (
        <ScheduleView
            schedules={schedules}
            students={students}
            teachers={teachers}
            onAdd={(d) => addItem("schedules", d)}
            onUpdate={(d) => updateItem("schedules", d.id, d)}
            onDelete={(id) => deleteItem("schedules", id)}
            selectedDepartment={selectedDepartment}
            userProfile={userProfile}
            theme={currentTheme}
            onNavigateToMemberDetail={handleNavigateToMemberDetail}
        />
    );
}

export function renderFinanceMenuContent({
    finances,
    annualBudget,
    handleUpdateAnnualBudget,
    addItem,
    deleteItem,
    updateItem,
    userProfile,
    selectedDepartment,
    currentTheme
}) {
    return (
        <FinanceView
            finances={finances}
            annualBudget={annualBudget}
            onUpdateAnnualBudget={handleUpdateAnnualBudget}
            onAdd={(d) => addItem("finances", d)}
            onDelete={(id) => deleteItem("finances", id)}
            onUpdate={(d) => updateItem("finances", d.id, d)}
            userProfile={userProfile}
            selectedDepartment={selectedDepartment}
            theme={currentTheme}
        />
    );
}
